import styled from "styled-components";
import PropTypes from "prop-types";
import { device } from "../device";

const Paragraph = styled.p`
    margin: ${prop => prop.last ? '0' : '0 0 24px'};

    @media ${device.lg} {
        margin: ${prop => prop.last ? '0' : '0 0 32px'};
    }
`;

Paragraph.propTypes = {
    last: PropTypes.bool
};

export default Paragraph